import { styled } from '@material-ui/core';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import React from 'react';
import { ReactComponent as Bancontact } from '../../weborder/assets/images/bancontact.svg';
import { ReactComponent as Apple } from '../../weborder/assets/images/ico_paymethod_apple.svg';
import { ReactComponent as GoogleMicrosoft } from '../../weborder/assets/images/ico_paymethod_google_ms.svg';
import { ReactComponent as PayPal } from '../../weborder/assets/images/ico_paymethod_paypal.svg';
import { ReactComponent as Ideal } from '../../weborder/assets/images/ideal.svg';

export const AppleIcon = Apple;

export const BancontactIcon = styled(Bancontact)({
  '& .cls-1': { fill: '#004e91' },
  '& .cls-2': { fill: '#fd0' }
});

export { CreditCardIcon };

export const CashPaymentIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <ellipse cx="12" cy="12" rx="4" ry="5" />
    <path d="M19.78,3H0V21H24V3ZM22,16a3,3,0,0,0-3,3H5a3,3,0,0,0-3-3V8A3,3,0,0,0,5,5H19a3,3,0,0,0,3,3Z" />
  </SvgIcon>
);

export const GoogleMicrosoftIcon = styled(GoogleMicrosoft)({
  '& .cls-1': { fill: '#f35325' },
  '& .cls-2': { fill: '#81bc06' },
  '& .cls-3': { fill: '#05a6f0' },
  '& .cls-4': { fill: '#ffba08' },
  '& .cls-5': { fill: '#4285f4' },
  '& .cls-6': { fill: '#34a853' },
  '& .cls-7': { fill: '#fbbc04' },
  '& .cls-8': { fill: '#ea4335' }
});

export const IdealIcon = Ideal;

export const PayPalIcon = styled(PayPal)({
  '& .cls-1': { fill: '#253b80' },
  '& .cls-2': { fill: '#179bd7' },
  '& .cls-3': { fill: '#222d65' }
});
